import { Button, Stack, Text } from "@chakra-ui/react"

interface SuccessMessageStepProps {
    onBackToLogin: () => void
    buttonColor: string
}

const SuccessMessageStep = ({ onBackToLogin, buttonColor }: SuccessMessageStepProps) => {
    return (
        <Stack spacing={5} textAlign={'center'}>
            <Stack align={'center'}>
                <Text fontSize='3xl' fontWeight={'300'}>Success!</Text>
            </Stack>
            <Stack spacing={0} textAlign={'center'}>
                <Text fontSize='md' fontWeight={'200'}>Your new password</Text>
                <Text fontSize='md' fontWeight={'200'}>has been sent to your email.</Text>
            </Stack>
            <Button
                bg={buttonColor}
                onClick={onBackToLogin}
                color={'white'}
                _hover={{
                    bg: 'blue.400',
                }}>
                Back to Login
            </Button>
        </Stack>
    )
}

export default SuccessMessageStep
